document.documentElement.classList.add('js');

(function(){
  const header = document.querySelector('.site-header');
  if(!header) return;
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

(function(){
  document.querySelectorAll('[data-qty-change]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      const step = btn.dataset.qtyChange === 'plus' ? 1 : -1;
      const next = Math.max(1, parseInt(input.value || '1', 10) + step);
      input.value = next;
    });
  });
})();


(function(){
  const items = document.querySelectorAll('.reveal-on-scroll');
  if(!items.length || !('IntersectionObserver' in window)) {
    items.forEach(el => el.classList.add('in-view'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting){
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
  items.forEach(el => observer.observe(el));
})();


(function(){
  const select = document.querySelector('[data-product-variant-select]');
  const mapEl = document.querySelector('[data-variant-image-map]');
  const mainImage = document.querySelector('[data-main-product-image]');
  const priceEl = document.querySelector('[data-product-price]');
  const addButton = document.querySelector('[data-add-to-cart-button]');
  const thumbButtons = document.querySelectorAll('[data-thumb-src]');

  if (thumbButtons.length && mainImage) {
    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const src = button.getAttribute('data-thumb-src');
        const alt = button.getAttribute('data-thumb-alt') || '';
        if (src) {
          mainImage.src = src;
          mainImage.alt = alt;
        }
        thumbButtons.forEach((b) => b.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  }

  if (!select || !mapEl || !mainImage) return;

  let variantMap = {};
  try {
    variantMap = JSON.parse(mapEl.textContent || '{}');
  } catch(e) {
    return;
  }

  const updateVariantImage = () => {
    const variant = variantMap[select.value];
    if (!variant) return;

    if (variant.image) {
      mainImage.src = variant.image;
      mainImage.alt = variant.alt || mainImage.alt || '';
    }

    if (priceEl && variant.price) {
      priceEl.textContent = variant.price;
    }

    if (addButton) {
      if (variant.available) {
        addButton.disabled = false;
        addButton.textContent = 'Pridať do košíka';
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Vypredané';
      }
    }

    thumbButtons.forEach((b) => b.classList.remove('is-active'));
  };

  select.addEventListener('change', updateVariantImage);
})();
